import DialogTrialGift from '~/components/categories/dialog/DialogTrialGift.vue';
import type { CategorySchema } from '~/types/schema';
import { getCategoryRouterAction } from '~/lib/category/actionHelper';

export const useCategoryLinkTryAndLock = async (category: CategorySchema) => {
  const { $db } = useNuxtApp();

  const dialog = useDialogStore();

  const { currentContent, categoryLockState, categoryTrialContent } =
    inject(INJECT_CATEGORY_PAGE);

  const route = useRoute();

  const { routeLink, isLocked, linkedContent, iconName } =
    await getCategoryRouterAction(
      $db,
      category,
      currentContent.value,
      categoryLockState.value.getIsTypeLocked,
      route.path
    );

  const { isTrialItem, isATrialType, isTrialAvailable } =
    useCategoryTrialContentItemInfos(
      categoryTrialContent,
      linkedContent,
      isLocked
    );

  const dialogLockedContent = useDialogLockedContent();

  const handleClickPath = (e) => {
    if (isLocked && isATrialType.value) {
      if (isLocked && !isTrialAvailable.value) {
        e.preventDefault();
        dialogLockedContent.open(
          linkedContent.lockedContent,
          null,
          null,
          useAppEventShare(
            EventAssociatedModel.ContentLockScreen,
            linkedContent.id,
            linkedContent.contentType || linkedContent.lockedContent
          )
        );
      } else if (isLocked && isTrialAvailable.value && !isTrialItem.value) {
        dialog.open(DialogTrialGift, {
          position: 'center',
          level: DialogLevel.Info,
          onConfirm: async () => {
            await categoryTrialContent.saveTrialProgression(
              linkedContent.lockedContent || linkedContent.contentType,
              linkedContent.id
            );
            dialog.close();
            navigateTo(routeLink.path);
          },
        });
        e.preventDefault();
      }
    } else if (isLocked) {
      e.preventDefault();
      dialogLockedContent.open(
        linkedContent.lockedContent,
        null,
        null,
        useAppEventShare(
          EventAssociatedModel.ContentLockScreen,
          linkedContent.id,
          linkedContent.contentType || linkedContent.lockedContent
        )
      );
    }
  };

  return {
    handleClickPath,
    isTrialItem,
    routeLink,
    iconName,
    linkedContent,
  };
};
